import port1 from "../img/portImages/1.jpg";
import port2 from "../img/portImages/2.jpg";
import port3 from "../img/portImages/3.jpg";
import port4 from "../img/portImages/5.jpg";
import port6 from "../img/portImages/8.jpg";
import port7 from "../img/portImages/7.jpg";
import port8 from "../img/portImages/9.jpg";
import port9 from "../img/portImages/10.jpg";
import port10 from "../img/portImages/11.jpg";
import port11 from "../img/portImages/14.jpg";
import port12 from "../img/portImages/15.jpg";
import port13 from "../img/portImages/16.jpg";
import port14 from "../img/portImages/17.jpg";
import port15 from "../img/portImages/18.jpg";
import port16 from "../img/portImages/19.jpg";

const portfolios = [
  {
    id: 1,
    category: "Listy",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port1,
    title: "List proszalny",
    desc:
      "„List, z reguły w formacie zbliżonym do A4 składał się zawsze z dwóch istotnych elementów - części napisanej przez jakąś litościwą duszę oraz części artystycznej, której autorem był Nikifor.”",
  },
  {
    id: 2,
    category: "Listy",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port2,
    title: "List proszalny",
    desc:
      "„Niektóre listy były dodatkowo oprawiane w rameczki z pasków kolorowego papieru - podobnie jak prace Nikifora.”",
  },
  {
    id: 3,
    category: "Listy",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port3,
    title: "List proszalny",
    desc:
      "„Na treść części pisemnej składały się; informacja o Nikiforze, krótki opis niedoli artysty, informacja o jego malarskiej profesji, prośba o wspomożenie oraz zachęta do nabywania obrazków.”",
  },
  {
    id: 4,
    category: "Kredki",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port4,
    title: "Kobieta na tle miasteczka",
    desc: "",
  },
  {
    id: 5,
    category: "Kredki",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port6,
    title: "Motyw Miejski",
  },
  {
    id: 6,
    category: "Kredki",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port7,
    title: "Żołnierz",
  },
  {
    id: 7,
    category: "Ołówki",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port8,
    title: "Rzeszów",
  },
  {
    id: 8,
    category: "Ołówki",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port9,
    title: "Dom w Krynicy",
  },
  {
    id: 9,
    category: "Ołówki",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port10,
    title: "Kościół",
    desc: "ok. 1966'",
  },
  {
    id: 10,
    category: "Akwarele",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port11,
    title: "Krynica",
  },
  {
    id: 11,
    category: "Akwarele",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port12,
    title: "Ulica w Tarnowie",
  },
  {
    id: 12,
    category: "Akwarele",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port13,
    title: "Kościół w Muszynie",
  },
  {
    id: 13,
    category: "Oleje",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port14,
    title: "Willa w Krynicy",
    desc:
      "„Zarówno w zbiorach muzealnych, jak i zbiorach prywatnych znaleźć pracę w technice olejnej wykonaną przez tego artystę jest dosyć trudno.”",
  },
  {
    id: 14,
    category: "Oleje",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port15,
    title: "Miasto z wieżą zegarową",
    desc:
      "„Wniosek, że obrazy w technice olejnej Nikifor malował w latach 30-ych nasuwa się po starannej analizie starych zdjęć artysty, które pokazują nie tylko artystę, jako człowieka młodego czy w sile wieku, ale też w dobrej kondycji.”",
  },
  {
    id: 15,
    category: "Oleje",
    link1: "https://nikifor.naiveart.pl",
    link2: "www.github.com",
    icon1: "Bogdan Karski",
    icon2: "Y",
    image: port16,
    title: "Willa Małopolanka",
    desc:
      "„Prace olejne Nikifor wykonywał z reguły na tekturze. Sam w sobie, wybór podobrazia jest poprawny, gdyż wielu artystów wykorzystywało dla prac olejnych podobrazie tekturowe lub deskę a nie płótno, ale z pewnością robił to po swojemu i wykorzystywał materiał przypadkowy w postaci odpadów.”",
  },
];

export default portfolios;
